import React, { Component } from "react";
import ReactDOM from 'react-dom';
import { PhotoImage, PhotoPlaceholder } from "../photoImage/photoImage";
import { Modal, Input, Button } from 'antd';

export class UserPhoto extends Component {
  constructor(props) {
    super(props);
    this.state = { photoURL: this.props.photoURL || '', hideRemoveButton: this.props.hideRemoveButton || false };
  }

  componentWillMount() {
    this.photoInputRef = null;
  }

  readLoadedImage = (event) => {
    event.preventDefault();
    const file = event.target.files[0];
    if(file.type === 'image/jpeg' || file.type === 'image/png') {
      let reader = new FileReader();
      reader.onloadend = () => {
        this.props.onPhotoLoad(reader.result);
        this.setState({...this.state, photoURL: reader.result})
      };
      reader.readAsDataURL(file);
    } else {
      Modal.error({
        title: 'Error',
        content: (
          <div>
            The specified file <i><b>{file.name}</b></i> could not be uploaded. The image is invalid or not supported.
            <br />
            <br />
            Allowed types: <b>.png</b>, <b>.jpg</b>, <b>.jpeg</b>
          </div>
        ),
        width: 510
      });
    }

  };

  removePhoto = () => {
    this.props.onPhotoRemove();
    this.setState({...this.state, photoURL: ''});
  };

  addPhoto = () => {
    ReactDOM.findDOMNode(this.photoInputRef).click()
  };

  renderImagePreview() {
    return(
      <div className="profile-form__user-photo">
        { this.state.photoURL ? <PhotoImage imageURL={this.state.photoURL}/> : <PhotoPlaceholder/> }
      </div>
    );
  }

  render() {
    return (
      <div className="profile-page__photo-block">
        {this.renderImagePreview()}
        <div className="profile-form__item--hidden">
          <Input ref={(ref) => this.photoInputRef = ref}
                 type="file"
                 onChange={this.readLoadedImage} />
        </div>
        <div className="profile-form__photo-controls">
          {this.state.photoURL && !this.state.hideRemoveButton && (
            <Button type="danger" onClick={this.removePhoto} className="profile-form__inactive-button">
              REMOVE
            </Button>
          )}
          <Button onClick={this.addPhoto} className="profile-form__inactive-button profile-form__add-photo-button">
            ADD NEW
          </Button>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/common/userPhoto/userPhoto.js